import moment from 'moment';
import { Timeslot } from './support-upgrade/types';
import { CaseSubCategory, FreeTime, ProductLine, SubCategoryOption } from './support.interface';

export const SUB_CATEGORY_GROUP = {
    FlashArray: ProductLine.FlashArray,
    FlashBlade: ProductLine.FlashBlade,
    Portworx: ProductLine.Portworx,
    Pure1: 'Pure1',
    EvergreenOne: 'Evergreen//One and //Flex',
    DisasterRecovery: 'Pure Protect //DRaaS',
    Others: 'Other',
};

const FLASH_ARRAY_GROUP = [
    {
        group: SUB_CATEGORY_GROUP.FlashArray,
        displayName: 'Hardware',
        subCategory: CaseSubCategory.HARDWARE_HARDWARE,
        productLine: ProductLine.FlashArray,
    },
    {
        group: SUB_CATEGORY_GROUP.FlashArray,
        displayName: 'Software',
        subCategory: CaseSubCategory.SOFTWARE_SOFTWARE,
        productLine: ProductLine.FlashArray,
    },
    {
        group: SUB_CATEGORY_GROUP.FlashArray,
        displayName: 'Environmental',
        subCategory: CaseSubCategory.ENVIRONMENTALS_NON_SPECIFIC,
        productLine: ProductLine.FlashArray,
    },
];

const FLASH_BLADE_GROUP = [
    {
        group: SUB_CATEGORY_GROUP.FlashBlade,
        displayName: 'Hardware',
        subCategory: CaseSubCategory.HARDWARE_HARDWARE,
        productLine: ProductLine.FlashBlade,
    },
    {
        group: SUB_CATEGORY_GROUP.FlashBlade,
        displayName: 'Software',
        subCategory: CaseSubCategory.SOFTWARE_SOFTWARE,
        productLine: ProductLine.FlashBlade,
    },
    {
        group: SUB_CATEGORY_GROUP.FlashBlade,
        displayName: 'Environmental',
        subCategory: CaseSubCategory.ENVIRONMENTALS_NON_SPECIFIC,
        productLine: ProductLine.FlashBlade,
    },
];

const PORTWORX_GROUP = [
    {
        group: SUB_CATEGORY_GROUP.Portworx,
        displayName: 'Software',
        subCategory: CaseSubCategory.SOFTWARE_SOFTWARE,
        productLine: ProductLine.Portworx,
    },
    {
        group: SUB_CATEGORY_GROUP.Portworx,
        displayName: 'Environmental',
        subCategory: CaseSubCategory.ENVIRONMENTALS_NON_SPECIFIC,
        productLine: ProductLine.Portworx,
    },
];

const PURE1_GROUP = [
    {
        group: SUB_CATEGORY_GROUP.Pure1,
        displayName: 'Fleet',
        subCategory: CaseSubCategory.ADMINISTRATIVE_SUBSCRIPTION_ONBOARD_OFFBOARD,
        productLine: ProductLine.None,
    },
    {
        group: SUB_CATEGORY_GROUP.Pure1,
        displayName: 'User & Security',
        subCategory: CaseSubCategory.ADMINISTRATIVE_ACCOUNT_ADJUSTMENT,
        productLine: ProductLine.None,
    },
    {
        group: SUB_CATEGORY_GROUP.Pure1,
        displayName: 'Software',
        subCategory: CaseSubCategory.ADMINISTRATIVE_GENERAL_INQUIRY,
        productLine: ProductLine.None,
    },
];

const EVERGREEN_ONE_GROUP = [
    {
        group: SUB_CATEGORY_GROUP.EvergreenOne,
        displayName: 'Usage & Billing',
        subCategory: CaseSubCategory.USAGE_AND_BILLING,
        productLine: ProductLine.None,
    },
    {
        group: SUB_CATEGORY_GROUP.EvergreenOne,
        displayName: 'Renewal & Expansions',
        subCategory: CaseSubCategory.RENEWALS_AND_EXPANSIONS,
        productLine: ProductLine.None,
    },
    {
        group: SUB_CATEGORY_GROUP.EvergreenOne,
        displayName: 'License',
        subCategory: CaseSubCategory.LICENSE_MANAGEMENT,
        productLine: ProductLine.None,
    },
    {
        group: SUB_CATEGORY_GROUP.EvergreenOne,
        displayName: 'Hardware',
        subCategory: CaseSubCategory.HARDWARE_MANAGEMENT,
        productLine: ProductLine.None,
    },
    {
        group: SUB_CATEGORY_GROUP.EvergreenOne,
        displayName: 'SLA',
        subCategory: CaseSubCategory.SLA_MANAGEMENT_REQUEST_SLA_CREDITS,
        productLine: ProductLine.None,
    },
];

const DISASTER_RECOVERY_GROUP = [
    {
        group: SUB_CATEGORY_GROUP.DisasterRecovery,
        displayName: 'Usage & Billing',
        subCategory: CaseSubCategory.ADMINISTRATIVE_ACCOUNT_ADJUSTMENT,
        productLine: ProductLine.DisasterRecovery,
    },
    {
        group: SUB_CATEGORY_GROUP.DisasterRecovery,
        displayName: 'Install & Config',
        subCategory: CaseSubCategory.ADMINISTRATIVE_ACCOUNT_ADJUSTMENT,
        productLine: ProductLine.DisasterRecovery,
    },
    {
        group: SUB_CATEGORY_GROUP.DisasterRecovery,
        displayName: 'Licence',
        subCategory: CaseSubCategory.SOFTWARE_REPLICATION,
        productLine: ProductLine.DisasterRecovery,
    },
    {
        group: SUB_CATEGORY_GROUP.DisasterRecovery,
        displayName: 'Backup',
        subCategory: CaseSubCategory.SOFTWARE_REPLICATION,
        productLine: ProductLine.DisasterRecovery,
    },
    {
        group: SUB_CATEGORY_GROUP.DisasterRecovery,
        displayName: 'Recovery',
        subCategory: CaseSubCategory.SOFTWARE_REPLICATION,
        productLine: ProductLine.DisasterRecovery,
    },
];

const OTHER_GROUP = [
    {
        group: SUB_CATEGORY_GROUP.Others,
        displayName: 'Other',
        subCategory: CaseSubCategory.ADMINISTRATIVE_GENERAL_INQUIRY,
        productLine: ProductLine.Others,
    },
];

export const SUB_CATEGORY_OPTIONS: SubCategoryOption[] = [
    ...FLASH_ARRAY_GROUP,
    ...FLASH_BLADE_GROUP,
    ...PORTWORX_GROUP,
    ...PURE1_GROUP,
    ...EVERGREEN_ONE_GROUP,
    ...DISASTER_RECOVERY_GROUP,
    ...OTHER_GROUP,
];

export const getSubCategoryOption = (productLine: ProductLine, subCategory: CaseSubCategory): SubCategoryOption => {
    return SUB_CATEGORY_OPTIONS.find(item => item.productLine === productLine && item.subCategory === subCategory);
};

// Exported to unit test...
export function splitUpSlots(freetimes: FreeTime[], duration: moment.Duration, interval: moment.Duration): Timeslot[] {
    const result: Timeslot[] = [];
    for (let i = 0; i < freetimes.length; i++) {
        const freeTime = freetimes[i];
        const end = moment(freeTime.end).subtract(duration);

        for (const start = moment(freeTime.start); start.isSameOrBefore(end); start.add(interval)) {
            result.push({
                startTime: moment(start),
                duration: duration,
                capacity: freeTime.capacity,
            });
        }
    }
    return result;
}
